//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
/**
 * Created by z003f2zh on 20.07.2016.
 */

(function () {

    'use strict';

    angular.module('container.widgets')
        .directive('srsngTableColumnFilter', srsngTableColumnFilter);

    function srsngTableColumnFilter($timeout) {

        return {
            restrict: 'E',
            scope: true,
            transclude: {
                filterSection: '?srsngTableColumnFilterFilterSection',
                sortSection: '?srsngTableColumnFilterSortSection'
            },
            templateUrl: 'container/ui/app/widgets/mega-table/filter/filter.html',
            controller: controller,
            link: link
        };

        function controller($scope) {
            $scope.filter();
        }

        function link(scope, element, attrs) {

            element.on('$destroy', function () {
                scope.$evalAsync(function () {
                    scope.$destroy();
                });
            });
        }
    }
})();
